<template>
  <div class="RouteContainer">
    <app-gallery-section :sectionIndex="0"/>
  </div>
</template>

<script>
import appGallerySection from './../gallery/gallery-section'

export default {
  name: 'meetTheWolf',

  components: {
    appGallerySection
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/meet-the-wolf.vue